import React from "react";
import graphql from "graphql";
import styled from "styled-components";
import { Box } from "rebass";
import Helmet from "react-helmet";

import Content, { HTMLContent } from "../components/Content";
import Header from "../components/Header";
import Connect from "../components/Connect";
import Circle from "../components/ui/Circle";
import StyledWrap from "../components/ui/StyledWrap";

type PageProps = {
  title: string,
  content: string,
  contentComponent: React.Node
};

export const PageTemplate = ({
  title,
  content,
  contentComponent
}: PageProps) => {
  const PageContent = contentComponent || Content;

  return (
    <Box>
      <Helmet htmlAttributes={{ class: "internal-page" }} />

      <div className="container">
        <StyledWrap px={[3, 3, 4, 6]} mb={[5, 5, 6]}>
          <Header title={title} my={[5, 5, 6]} />

          <ContentBox mx="auto" mb={[5, 5, 6]}>
            <PageContent className="content" content={content} />
          </ContentBox>

          <CircleGroup>
            <Circle
              style={{ position: "absolute", left: "22px", top: "15px" }}
              opacity={0.17}
            />
            <Circle
              r={8}
              style={{ position: "absolute", left: "32px", top: "32px" }}
            />
            <Circle
              r={16}
              style={{ position: "absolute", left: "46px", top: "46px" }}
              opacity={0.3}
            />
          </CircleGroup>

          <Circle
            r={56}
            style={{ position: "absolute", right: "-34px", top: "-34px" }}
            opacity={0.15}
          />

          <Circle
            r={36}
            style={{ position: "absolute", left: "-37px", top: "20%" }}
            opacity={0.15}
          />

          <Circle
            r={100}
            style={{ position: "absolute", right: "-101px", top: "40%" }}
            opacity={0.1}
          />

          <Circle
            r={20}
            style={{ position: "absolute", left: "-21px", top: "60%" }}
            opacity={0.15}
          />

          <Circle
            r={200}
            style={{ position: "absolute", right: "-201px", top: "90%" }}
            opacity={0.1}
          />
        </StyledWrap>

        <Connect
          mb={[5, 5, 6]}
          heading="Want more info? We're always happy to say hello..."
        />
      </div>
    </Box>
  );
};

type Props = {
  data: {}
};

export default ({ data }: Props) => {
  const { markdownRemark: post } = data;

  return (
    <PageTemplate
      contentComponent={HTMLContent}
      title={post.frontmatter.title}
      content={post.html}
    />
  );
};

// Styled Components
const ContentBox = styled(Box)`
  max-width: 800px;
  width: 100%;
`;

const CircleGroup = styled.div`
  position: absolute;
  left: -12px;
  top: -12px;
  transform: scale(0.8);

  @media (min-width: 48em) {
    left: 26px;
    top: 26px;
    transform: scale(1);
  }
`;

export const pageQuery = graphql`
  query defaultPage($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        path
        title
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/default-page.js